import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { toast } from 'react-toastify';
import ScrollToTop from 'react-scroll-to-top';
import { PropertyCard } from './PropertyCard';
import { ReasonModal } from './ReasonModal';
import { LeaveFeedbackModal } from './modals/LeaveFeedbackModal';
import * as AppConstants from '../AppConstants';
import { useNavigate } from 'react-router-dom';
import { BuyerPropertyAppointmentModal } from './modals/BuyerPropertyAppointmentModal';
import moment from 'moment-timezone';


export const BuyerProperties = () => {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState('');
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [reason, setReason] = useState('');
  const [checked, setChecked] = useState('');
  const [propertiesChecked, setPropertiesChecked] = useState('');
  const [description, setDescription] = useState('');
  const [comment, setComment] = useState('');
  const [propertyID, setPropertyID] = useState('');
  const [propertyRef, setPropertyRef] = useState(null);
  const [buyerPropertyId, setBuyerPropertyId] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [reasonError, setReasonError] = useState('');
  const [commentError, setCommentError] = useState('');
  const [userID] = useState(localStorage.getItem('userId'));
  const [staffMemberId] = useState(localStorage.getItem('staffMemberId'));
  const [feedbackError, setFeedbackError] = useState('');
  const [appointmentError, setAppointmentError] = useState('');
  const [feedback, setFeedback] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [buyerProperties, setBuyerProperties] = useState(location?.state?.properties);
  const navigate = useNavigate();


  useEffect(() => {
    document.title = 'Buyer Properties';
    window.scrollTo(0, 0);
  }, [location?.state?.properties]);

  const handleDelete = async (id) => {
    const options = {
      method: 'DELETE',
      url: `/BuyerProperty/${id.id}`,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    axios
      .request(options)
      .then((response) => {
        toast.success(
          `Property: ${id.propertyRef} has been removed`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        removeBuyerProperty(id.id);
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };
  
  const removeBuyerProperty = (buyerPropertyId) => {
    let filteredArray = buyerProperties.filter(item => item.id !== buyerPropertyId)
    setBuyerProperties(filteredArray);
  }

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    //Only stores property id
    var updatedList = [...checked];
    //Stores full property obj
    var propertyUpdatedList = [...propertiesChecked];

    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
      propertyUpdatedList = [...propertiesChecked, JSON.parse(event.target.getAttribute('data-property'))];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
      propertyUpdatedList.splice(checked.indexOf(JSON.parse(event.target.getAttribute('data-property'))), 1);
    }
    setChecked(updatedList);
    setPropertiesChecked(propertyUpdatedList);
  };

  const handleReasonChange = (event) => {
    setReasonError(null);
    setReason(event.value);
    setDescription(event.label);
  };

  const fetchReason = () => {
    const options = {
      method: 'GET',
      url: `/propertyfavouritereason`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return {
            value: element.id,
            label: element.description,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const mutation = useMutation(handleDelete, {
    onError: (err, _id, context) => {
      queryClient.setQueryData('Favourites', context.previousValue);
      toast.error(`Server error, Please try again later`, {
        position: 'top-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    },
  });

  const { data: reasonData } = useQuery(['Reason'], fetchReason, { refetchOnWindowFocus: false });

  const reasonModal = (e, id, propertyRef, localReason = null) => {
    if (localReason) {
      setReason(localReason);
    }
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
    setPropertyID(id);
    setPropertyRef(propertyRef);
  };

  const feedbackModal = (e, propertyId, propertyRef, buyerPropertyId) => {
    e.preventDefault();
    e.stopPropagation();
    setShowFeedbackModal(true);
    setPropertyID(propertyId);
    setPropertyRef(propertyRef);
    setBuyerPropertyId(buyerPropertyId)
  };

  const appointmentModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (checked.length < 1) {
      //No properties selected, show error
      toast.error(
        `Select at least one property`,
        {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      return;
    }
    setShowAppointmentModal(true);
  };

  const navigateViewingSheet = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (checked.length < 1) {
      //No properties selected, show error
      toast.error(
        `Select at least one property`,
        {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      return;
    }
    navigate("/ViewingSheetForm", 
      { state: 
        { 
          properties: propertiesChecked,
          buyerName: location?.state?.buyerName,
          buyerSpecId: location?.state?.buyerSpecId,
          selectedPropertiesIds: checked,
          buyerEmail: location?.state?.buyerEmail
        }
      });
  };

  const handleComment = (e) => {
    setCommentError(null);
    setComment(e.target.value);
  };

  const handleFeedback = (e) => {
    setFeedbackError(null);
    setFeedback(e.target.value);
  };

  const addFavourite = async (e) => {
    setDisabled(true);
    if (!reason) {
      setReasonError("Reason input can't be emptied");
      setDisabled(false);
      return;
    }
    if (!comment) {
      setCommentError("Comment input can't be emptied");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toISOString();

    const config = {
      method: 'POST',
      url: '/propertyfavourite',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        sys_UserId: userID,
        dateRegistered: isoDate,
        propertyFavouriteReasonId: reason,
        comments: comment,
      }),
    };

    try {
      const data = await axios(config);
      if (data.status == 201) {
        setReason('');
        setComment('');
        setDisabled(false);
        toast.success(
          `Property: ${propertyRef} has been added to Favourites`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowModal(false);
      }
    } catch (err) {
      if (
        err.response.status === 400 &&
        err.response.data.message ===
          'bizrule_propertyFavourite_favouriteReasonAlreadyExists'
      )
        toast.error(
          `Property: ${propertyRef} wasn't added, It has been already added`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      if (err.response.status === 500)
        toast.error(
          `Server error. Property: ${propertyRef} wasn't added, try again later`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      setComment('');
      setDisabled(false);
    }
  };

  const postPropertyFeedback = async (e) => {
    setDisabled(true);
    if (!feedback) {
      setFeedbackError("Feedback is required");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toISOString();

    const config = {
      method: 'POST',
      url: '/note/LeavePropertyFeedback',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        documentContextId: AppConstants.DocumentContextId_Property,
        noteContextId: AppConstants.NoteContextId_PropertyFeedback,
        recordId: propertyID,
        buyerPropertyId: buyerPropertyId,
        subject: 'Feedback from Buyer Ref ' + location?.state?.buyerRef,
        postedBy: localStorage.getItem('username'),
        noteDate: isoDate,
        staffMemberName: JSON.parse(localStorage.getItem('staffMemberInfo')).reportingName,
        noteText: feedback
      }),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        setFeedback('');
        setDisabled(false);
        toast.success(
          `Feedback posted on Property Ref ${propertyRef}`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowFeedbackModal(false);
      }
    } catch (err) {
      if (
        err.response.status === 400 &&
        err.response.data.message ===
          'bizrule_propertyFavourite_favouriteReasonAlreadyExists'
      )
        toast.error(
          `Property: ${propertyRef} wasn't added, It has been already added`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      if (err.response.status === 500)
        toast.error(
          `Server error. Property: ${propertyRef} wasn't added, try again later`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
      setComment('');
      setDisabled(false);
    }
  };

  const postAppointment = async (e) => {
    setDisabled(true);
    if (!startDate || !startTime || !endTime) {
      setAppointmentError("Date and time is required");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toISOString();

    let data = [];

    checked.forEach((propertyId) => {
      data.push(
        {
          AppointmentType: 1, //Appointment with Buyer
          RecordRefId: location?.state?.buyerSpecId,
          BuyerSpecId: location?.state?.buyerSpecId,
          PropertyId: parseInt(propertyId),
          AppointmentDate: moment(startDate).utc(true),
          AppointmentStart: moment(startTime).utc(true),
          AppointmentEnd: moment(endTime).utc(true),
          StaffMemberId: parseInt(staffMemberId),
          Status: 1, //Confirmed
        }
      )
    });

    const config = {
      method: 'POST',
      url: '/Appointment/CreateBuyerAppointmentFromMobile',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        setFeedback('');
        setDisabled(false);
        toast.success(
          `Appointment created successfully`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowAppointmentModal(false);
      }
    } catch (err) {
      if (err.response.status === 500)
      setComment('');
      setDisabled(false);
    }
  };


  return (
    <div className="container vh-100">
      <ScrollToTop smooth color="#6f00ff" />
      <div className='row'>
        <div className="col-9 col-xl-9 col-xl-9 ml-0 p-0">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            <i className="fas fa-home" aria-hidden="true"></i>
            {location?.state?.buyerName} Properties
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
          <p className="btn btn-danger d-block" onClick={() => navigate(-1)}>
            Back
          </p>
        </div>
      </div>
      <div className="h6 mb-3 ml-0">
        You have{' '}
        {buyerProperties?.length > 1
          ? `${buyerProperties?.length} listed properties.`
          : `${buyerProperties?.length} listed property`}{' '}
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group has-search w-100">
            <span className="fa fa-search form-control-feedback"></span>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
        
      <div className="row">
        <div className="col-6 text-center">
          <button className="btn btn-primary mb-4" onClick={appointmentModal} >
            Appointment
          </button>
        </div>
        <div className="col-6 text-center">
          <button className="btn btn-primary mb-4" onClick={navigateViewingSheet} >
            Viewing Sheet
          </button>
        </div>
      </div>

      <div className="row">
        {buyerProperties?.length < 1 ? (
          <h4 className="mx-auto">No search results found</h4>
        ) : null}
        <div className="container pl-0 pr-0">
          <div className="row mb-4">
            {buyerProperties &&
              React.Children.toArray(
                buyerProperties?.map((buyerProperty, index) => (
                  <PropertyCard
                    property={buyerProperty.property}
                    index={index}
                    location={location}
                    mutation={mutation}
                    showHotBtn={true}
                    showFeedbackBtn={true}
                    showSelectCheckbox={true}
                    reasonModal={reasonModal}
                    feedbackModal={feedbackModal}
                    buyerProperty={buyerProperty}
                    handleCheck={handleCheck}
                    showRemoveBuyerPropertyBtn={true}
                   />
                )),
              )}
          </div>
          <p className="btn btn-danger d-block mb-4" onClick={() => navigate(-1)}>
            Back
          </p>
        </div>
      </div>
      <ReasonModal
          showModal={showModal}
          reason={reason}
          setReason={setReason}
          setReasonError={setReasonError}
          setCommentError={setCommentError}
          setShowModal={setShowModal}
          reasonError={reasonError}
          handleReasonChange={handleReasonChange}
          reasonData={reasonData}
          comment={comment}
          handleComment={handleComment}
          commentError={commentError}
          disabled={disabled}
          addFavourite={addFavourite}
        />
        <LeaveFeedbackModal
          showModal={showFeedbackModal}
          setFeedbackError={setFeedbackError}
          setShowModal={setShowFeedbackModal}
          feedback={feedback}
          handleFeedback={handleFeedback}
          feedbackError={feedbackError}
          disabled={disabled}
          postFeedback={postPropertyFeedback}
        />
        <BuyerPropertyAppointmentModal
          showModal={showAppointmentModal}
          setAppointmentError={setAppointmentError}
          setShowModal={setShowAppointmentModal}
          startDate={startDate}
          startTime={startTime}
          endTime={endTime}
          setStartDate={setStartDate}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          appointmentError={appointmentError}
          disabled={disabled}
          postAppointment={postAppointment}
        />
    </div>
  );
};
